import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import PromoBanner from "@/components/PromoBanner";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Boutique from "@/pages/Boutique";
import Character from "@/pages/Character";
import MellowFriends from "@/pages/MellowFriends";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Histoire from "@/pages/Histoire";
import Feuilleter from "@/pages/Feuilleter";
import AdminNewsletter from "@/pages/AdminNewsletter";
import AdminOrders from "@/pages/AdminOrders";
import Suivi from "@/pages/Suivi";
import Product from "@/pages/Product";
import AdminReviews from "@/pages/AdminReviews";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import CGV from "@/pages/CGV";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <CartProvider>
        <BrowserRouter>
          <PromoBanner />
          <Header />
          <CookieBanner />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/boutique" element={<Boutique />} />
              <Route path="/boutique/:category" element={<Boutique />} />
              <Route path="/produit/:key" element={<Product />} />
              <Route path="/mellowfriends" element={<MellowFriends />} />
              <Route path="/personnages/:slug" element={<Character />} />
              <Route path="/panier" element={<Cart />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/histoire" element={<Histoire />} />
              <Route path="/feuilleter" element={<Feuilleter />} />
              <Route path="/suivi" element={<Suivi />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/admin/newsletter" element={<AdminNewsletter />} />
              <Route path="/admin/commandes" element={<AdminOrders />} />
              <Route path="/admin/avis" element={<AdminReviews />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
